export default "__VITE_ASSET__e15aee4f__"